export type ContractRow = {
  id: number;
  signatureLink?: string | null;
  signatureFinishedAt?: string | null;
};

/**
 * The one rule that every read of the funnel shares: a signed row first, then a
 * row that carries a Signature Link, and the highest id breaks a tie.
 */
export const contractRowOfTheCustomer = <TRow extends ContractRow>(
  rows: readonly TRow[] | undefined,
): TRow | undefined => {
  const rowsFromTheLatest = [...(rows ?? [])].sort(
    (one, other) => other.id - one.id,
  );

  return (
    rowsFromTheLatest.find((row) => row.signatureFinishedAt) ??
    rowsFromTheLatest.find((row) => row.signatureLink)
  );
};
